import { render, staticRenderFns } from "./InformationBox.vue?vue&type=template&id=71544468&scoped=true"
import script from "./InformationBox.vue?vue&type=script&lang=js"
export * from "./InformationBox.vue?vue&type=script&lang=js"
import style0 from "./InformationBox.vue?vue&type=style&index=0&id=71544468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71544468",
  null
  
)

export default component.exports